<template>
  <SelectBox
    class="custom-sortby mb-10"
    :text="sortByText"
    :options="dataSortby"
    :round="true"
    v-model:placeholder="sortTripsSelected.name"
    v-model:optionSelected="sortTripsSelected"
    @trigger="updateSortTripsSelected"
  ></SelectBox>
</template>

<script>
import SelectBox from '~/components/ui/selectbox/SelectBox'
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useRouterUtils } from '~/helper/useRouterUtils'

export default {
  components: {
    SelectBox,
  },
  // emits: ['sortTripsSelected'],
  props: {
    // sortTripsSelected: { type: Object },
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const { updatePathQuery } = useRouterUtils()
    const { isMobileOrTablet } = useDevice()
    // const optionSelectedBg = ref(true)
    const triggerStatus = ref(false)
    // const getSortTripsSelected = ref(props.sortTripsSelected)
    const sortTripsSelected = ref({
      id: 1,
      name: 'Most Popular',
      value: 'popular',
    })
    const dataSortby = [
      /*{
        id: 1,
        name: 'Recommended',
        value: 'recommended',
      },*/
      {
        id: 1,
        name: 'Most Popular',
        value: 'popular',
      },
      {
        id: 2,
        name: 'Price (lowest first)',
        value: 'price-ascending',
      },
      {
        id: 3,
        name: 'Price (highest first)',
        value: 'price-descending',
      },
      {
        id: 4,
        name: 'Duration (shortest first)',
        value: 'duration-ascending',
      },
      {
        id: 5,
        name: 'Duration (longest first)',
        value: 'duration-descending',
      },
    ]

    // provide('optionSelectedBg', optionSelectedBg)

    const updateSortTripsSelected = () => {
      updatePathQuery(router, { sort: sortTripsSelected.value.value })
    }


    const sortByText = computed(() => {
      if(isMobileOrTablet) return ''
      return 'Sort by'
    })

    watch(
      () => route.path,
      () => {
        sortTripsSelected.value = {
          id: 1,
          name: 'Most Popular',
          value: 'popular'
        }
      },
    )

    onMounted(async () => {
      const query = route.query.sort || 'popular'
      const selected = dataSortby.find((item) => item.value === query)

      sortTripsSelected.value = selected
      // updatePathQuery(router, { sort: sortTripsSelected.value.value })
    })

    return {
      triggerStatus,
      sortTripsSelected,
      dataSortby,
      updateSortTripsSelected, sortByText
    }
  },
}
</script>

<style></style>
